module.exports = __webpack_public_path__ + "images/screen-shots/attendance-63cdfd47e1ee4b604b1c1535e0c2e3e8.png";